"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePostBodyBroadcast = exports.BroadcastMode = exports.generateEndpointBroadcast = void 0;
function generateEndpointBroadcast() {
    return `/cosmos/tx/v1beta1/txs`;
}
exports.generateEndpointBroadcast = generateEndpointBroadcast;
var BroadcastMode;
(function (BroadcastMode) {
    BroadcastMode["Unspecified"] = "BROADCAST_MODE_UNSPECIFIED";
    BroadcastMode["Block"] = "BROADCAST_MODE_BLOCK";
    BroadcastMode["Sync"] = "BROADCAST_MODE_SYNC";
    BroadcastMode["Async"] = "BROADCAST_MODE_ASYNC";
})(BroadcastMode = exports.BroadcastMode || (exports.BroadcastMode = {}));
function generatePostBodyBroadcast(txRaw, broadcastMode = BroadcastMode.Sync) {
    return `{ "tx_bytes": [${txRaw.message
        .serializeBinary()
        .toString()}], "mode": "${broadcastMode}" }`;
}
exports.generatePostBodyBroadcast = generatePostBodyBroadcast;
//# sourceMappingURL=broadcast.js.map